import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=0896dfe7&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0896dfe7')) {
      api.createRecord('0896dfe7', component.options)
    } else {
      api.reload('0896dfe7', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=0896dfe7&", function () {
      api.rerender('0896dfe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/loader/Loader.vue"
export default component.exports